import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Home, ShieldAlert } from 'lucide-react';
import { useMetadata } from '../hooks/useMetadata';

export default function Forbidden() {
  const [cmsPage, setCmsPage] = useState(null);

  useEffect(() => {
    fetch('https://api.dev.auxo.dk/public/by-slug/da/403')
      .then((res) => {
        if (!res.ok) throw new Error('Kunne ikke hente 403 fra CMS');
        return res.json();
      })
      .then((data) => {
        if (data && data.collectionName === 'pages') {
          setCmsPage(data);
        }
      })
      .catch((err) => console.error(err));
  }, []);

  const title = cmsPage?.meta_title || 'Adgang nægtet - FLOW Transport & Logistik ApS';
  const description = cmsPage?.meta_description || 'Du har ikke tilladelse til at tilgå denne side.';

  useMetadata(title, description);

  return (
    <div className="min-h-[70vh] bg-slate-50 flex items-center justify-center px-4 py-16 font-sans">
      <div className="max-w-md w-full text-center space-y-6 bg-white p-8 sm:p-10 rounded-2xl shadow-3d-card border border-slate-100">
        <div className="inline-flex p-4 rounded-full bg-rose-50 text-rose-600">
          <ShieldAlert className="h-12 w-12" />
        </div>
        
        <h1 className="text-3xl font-serif font-bold text-brand-dark tracking-tight">
          {cmsPage?.title || '403 - Adgang nægtet'}
        </h1>

        <div
          className="text-slate-600 text-sm leading-relaxed"
          dangerouslySetInnerHTML={{ __html: cmsPage?.content || '<p>Du har ikke tilladelse til at tilgå denne side.</p>' }}
        />

        <div className="pt-4">
          <Link
            to="/"
            className="inline-flex items-center justify-center bg-brand-primary hover:bg-brand-primary/95 text-white px-6 py-3 rounded-lg text-sm font-bold uppercase tracking-wider transition-colors shadow cursor-pointer w-full"
          >
            <Home className="mr-2 h-4 w-4" />
            Gå til forsiden
          </Link>
        </div>
      </div>
    </div>
  );
}
